module.exports = __webpack_public_path__ + "media/images/result_sets/circles/6r7r9r3r-9f353d280fc1a571c1a8c9107b34f6fd.svg";